const WorkflowTestIndex = () => import('@/pages/lab/workflows/test/WorkflowTestIndex')
const WorkflowTestDetail = () => import('@/pages/lab/workflows/test/WorkflowTestDetail')
const WorkflowTestProcessDetail = () => import('@/pages/lab/workflows/test/WorkflowTestProcessDetail')
const WorkflowTestProcessAdd = () => import('@/pages/lab/workflows/test/WorkflowTestProcessAdd')
const WorkflowTestProcessEdit = () => import('@/pages/lab/workflows/test/WorkflowTestProcessEdit')
const WorkflowTestTaskDetail = () => import('@/pages/lab/workflows/test/WorkflowTestTaskDetail')
const WorkflowTestTaskAdd = () => import('@/pages/lab/workflows/test/WorkflowTestTaskAdd')
const WorkflowTestTaskEdit = () => import('@/pages/lab/workflows/test/WorkflowTestTaskEdit')

const WorkflowTestAuditTrail = () => import('@/pages/lab/workflows/test/WorkflowTestAuditTrail')
const WorkflowTestAuditTrailHistory = () => import('@/pages/lab/workflows/test/WorkflowTestAuditTrailHistory')
const WorkflowTestProcessAuditTrail = () => import('@/pages/lab/workflows/test/WorkflowTestProcessAuditTrail')
const WorkflowTestProcessAuditTrailHistory = () => import('@/pages/lab/workflows/test/WorkflowTestProcessAuditTrailHistory')
const WorkflowTestTaskAuditTrail = () => import('@/pages/lab/workflows/test/WorkflowTestTaskAuditTrail')
const WorkflowTestTaskAuditTrailHistory = () => import('@/pages/lab/workflows/test/WorkflowTestTaskAuditTrailHistory')

export class TestWorkflowRoutes {
  constructor () {
    this.route_root = 'test-workflows'
    this.type_single = 'Test Workflow'
    this.type_plural = 'Test Workflows'

    this.routes = [
      {
        path: this.route_root,
        component: { render (c) { return c('router-view') } },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: '',
            component: WorkflowTestIndex,
            meta: { requiresAuth: true }
          },
          {
            path: ':sample_type_id',
            component: { render (c) { return c('router-view') } },
            redirect: ':sample_type_id',
            name: `Test ${this.type_single}`,
            meta: { requiresAuth: true },
            children: [
              {
                path: '',
                component: WorkflowTestDetail,
                meta: { requiresAuth: true }
              },
              {
                path: 'audit-trail',
                name: 'Test Workflow Audit Trail',
                component: WorkflowTestAuditTrail,
                meta: { requiresAuth: true }
              },
              {
                path: 'audit-trail-history',
                name: 'Test Workflow Audit Trail History',
                component: WorkflowTestAuditTrailHistory,
                meta: { requiresAuth: true }
              },
              {
                path: 'add',
                name: 'Add Test Process',
                component: WorkflowTestProcessAdd,
                meta: { requiresAuth: true }
              },
              {
                path: ':test_process_id',
                name: 'Test Process',
                component: { render (c) { return c('router-view') } },
                redirect: ':test_process_id',
                meta: { requiresAuth: true },
                children: [
                  {
                    path: '',
                    component: WorkflowTestProcessDetail,
                    meta: { requiresAuth: true }
                  },
                  {
                    path: 'edit',
                    name: 'Edit Test Process',
                    component: WorkflowTestProcessEdit,
                    meta: { requiresAuth: true }
                  },
                  {
                    path: 'audit-trail',
                    name: 'Test Process Audit Trail',
                    component: WorkflowTestProcessAuditTrail,
                    meta: { requiresAuth: true }
                  },
                  {
                    path: 'audit-trail-history',
                    name: 'Test Process Audit Trail History',
                    component: WorkflowTestProcessAuditTrailHistory,
                    meta: { requiresAuth: true }
                  },
                  {
                    path: 'add',
                    name: 'Add Test Task',
                    component: WorkflowTestTaskAdd,
                    meta: { requiresAuth: true }
                  },
                  {
                    path: ':test_task_id',
                    name: 'Test Task',
                    component: { render (c) { return c('router-view') } },
                    redirect: ':test_task_id',
                    meta: { requiresAuth: true },
                    children: [
                      {
                        path: '',
                        component: WorkflowTestTaskDetail,
                        meta: { requiresAuth: true }
                      },
                      {
                        path: 'edit',
                        name: 'Edit Test Task',
                        component: WorkflowTestTaskEdit,
                        meta: { requiresAuth: true }
                      },
                      {
                        path: 'audit-trail',
                        name: 'Test Task Audit Trail',
                        component: WorkflowTestTaskAuditTrail,
                        meta: { requiresAuth: true }
                      },
                      {
                        path: 'audit-trail-history',
                        name: 'Test Task Audit Trail History',
                        component: WorkflowTestTaskAuditTrailHistory,
                        meta: { requiresAuth: true }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }

  static fetchRoutes () {
    const this_obj = new this()
    return this_obj.routes
  }

  static fetchPublicRoutes () {
    const this_obj = new this()
    return this_obj.public_routes
  }

  static fetchRoot () {
    const this_obj = new this()
    return this_obj.route_root
  }
}
